module.exports = {
  schema: {
    name: '商品',
    type: 'Object',
    contents: {
      ragicId: {
        name: 'Ragic Id',
        type: 'Number',
        ragicId: '_ragicId',
        disabled: true,
      },
      key: {
        type: 'String',
        name: '商品條碼',
        ragicId: '1000064',
      },
      name: {
        type: 'String',
        name: '商品名稱',
        ragicId: '1000065',
      },
      type: {
        type: 'String',
        name: '商品類別',
        input: 'select',
        options: ['A', 'B', 'C', 'D', 'E', 'F'],
        ragicId: '1000103',
      },
      brandRef: {
        type: 'ObjectId',
        reference: 'brands',
        refKeys: ['key'],
        input: 'select',
        name: '品牌代碼',
        ragicId: '1000128',
      },
      brandCode: {
        type: 'String',
        name: '品牌簡碼',
        ragicId: '1000106',
      },
      supplierRef: {
        type: 'ObjectId',
        reference: 'suppliers',
        name: '供應商名稱',
        refKeys: ['name'],
        input: 'select',
        ragicId: '1000001',
      },
      orderCode: {
        type: 'String',
        name: '訂貨代碼',
        ragicId: '1000186',
      },
      // fields never use
      isContract: {
        type: 'String',
        input: 'select',
        name: '是否為簽約商品',
        options: ['是', '否'],
        ragicId: '1000119',
      },
      orderFrom: {
        type: 'String',
        name: '訂貨單位',
        ragicId: '1000120',
      },
      payType: {
        type: 'String',
        input: 'select',
        name: '付款方式',
        options: ['現金', '匯款', '支票'],
        ragicId: '1000121',
      },
      spec: {
        type: 'String',
        name: '規格',
        ragicId: '1000177',
      },
      taxType: {
        type: 'String',
        name: '稅別',
        input: 'select',
        options: ['內含', '外加'],
        ragicId: '1000440',
      },
      basicAmount: {
        type: 'String',
        name: '基數',
        ragicId: '1000182',
      },
      origin: {
        type: 'String',
        name: '產地',
        ragicId: '1000108',
        input: 'select',
        options: [
          '韓國',
          '香港',
          '台灣',
          '日本',
          '中國',
          '義大利',
          '愛爾蘭/美國',
          '英國/美國',
          '大陸',
          '東南亞',
          '英商MONDOTTICA監製 (中國)',
          '德商STEPPER監製 (中國)',
          '中國/德商STEPPER監製',
        ],
      },
      unit: {
        type: 'String',
        name: '單位',
        ragicId: '1000268',
        input: 'select',
        options: ['支', '盒', '個', '台', '組', '本', '打', '條', '箱', '包', '片', '卷', '副'],
      },
      note: {
        type: 'String',
        name: '備註',
        ragicId: '1000122',
      },
      // prices
      centerCost: {
        type: 'Number',
        name: '管理中心成本',
        ragicId: '1000132',
      },
      storeCost: {
        type: 'Number',
        name: '門市成本',
        ragicId: '1000109',
      },
      price: {
        type: 'Number',
        name: '定價',
        ragicId: '1000110',
      },
      staffPrice: {
        type: 'Number',
        name: '員配價',
        ragicId: '1000416',
      },
      salePrice: {
        type: 'Number',
        name: '售價',
        ragicId: '1000111',
      },
      // A rim
      model: {
        type: 'String',
        name: '型號',
        ragicId: '1000112',
      },
      colorRef: {
        type: 'ObjectId',
        reference: 'typeAColors',
        name: '顏色',
        refKeys: ['key'],
        input: 'select',
        ragicId: '1000118',
      },
      colorCode: {
        type: 'String',
        name: '色號',
        ragicId: '1000116',
      },
      size: {
        type: 'Number',
        name: '尺寸',
        ragicId: '1000114',
      },
      material: {
        type: 'String',
        name: '材質',
        ragicId: '1000113',
        input: 'select',
        options: [
          'F-塑膠',
          'B-混合',
          'C-板料',
          'A-合金',
          'D-純鈦',
          'E-TR90',
          'G-β鈦',
          'I-板鈦',
          'H-記憶鈦',
          'J-Ultem',
          'K-INFINO',
          'L-Grilamid',
          'M-TR1000',
          'N-板料/TR',
          'O-Z鈦',
          'P-塑鋼',
        ],
      },
      contour: {
        type: 'String',
        name: '外型',
        ragicId: '1000115',
        input: 'select',
        options: [
          'L-一般型',
          'M-方圓型',
          'E-加掛',
          'I-長方型',
          'H-長扁型',
          'R-大框一般型',
          'O-大框長方型',
          'T-小框長扁型',
          'X-小框一般型',
          'U-小框長方型',
          'D-兒童',
          'V-小框圓型',
          'J-圓型',
          'K-橢圓型',
          'C-運動',
          'F-太陽架',
          'Y-小框方圓型',
          'Z-特殊型',
          'W-小框橢圓型',
          'S-大框方圓型',
          'N-大框長扁型',
          'G-太陽架(兒童)',
          'A-傳統男框',
          'Q-大框橢圓型',
          'P-大框圓型',
          'R-太陽眼鏡(徧光)',
          'F3-運動太陽眼鏡(水銀偏光防霧)',
          'F4-運動太陽眼鏡(偏光防霧)',
          '方橢',
          '方型',
        ],
      },
      rimType: {
        type: 'String',
        name: '類型',
        ragicId: '1000117',
        input: 'select',
        options: ['A-全框', 'B-半框', 'C-無邊(一般)', 'D-無邊(思樂)', 'E-摺疊', 'F-掛片', 'I-長方型'],
      },
      templeLength: {
        type: 'Number',
        name: '腳長',
        ragicId: '1000185',
      },
      // B glasses
      lensTypeRef: {
        type: 'ObjectId',
        reference: 'lensTypes',
        refKeys: ['key'],
        input: 'select',
        name: '片種代碼',
      },
      sphereMax: {
        type: 'Number',
        name: 'S',
        ragicId: '1000156',
      },
      sphereMin: {
        type: 'Number',
        name: '~S',
        ragicId: '1000157',
      },
      cylinderMax: {
        type: 'Number',
        name: 'C',
        ragicId: '1000158',
      },
      cylinderMin: {
        type: 'Number',
        name: '~C',
        ragicId: '1000159',
      },
      axisMax: {
        type: 'Number',
        name: 'A',
        ragicId: '1000192',
      },
      axisMin: {
        type: 'Number',
        name: '~A',
        ragicId: '1000193',
      },
      addMax: {
        type: 'Number',
        name: 'ADD',
        ragicId: '1000160',
      },
      addMin: {
        type: 'Number',
        name: '~ADD',
        ragicId: '1000161',
      },
      SCMax: {
        type: 'Number',
        name: 'S+C',
        ragicId: '1000162',
      },
      SCMin: {
        type: 'Number',
        name: '~S+C',
        ragicId: '1000506',
      },
      progressive: {
        type: 'Number',
        name: '累進帶',
        ragicId: '1000232',
      },
      diameter: {
        type: 'String',
        name: '直徑',
        ragicId: '1000187',
      },
      coating: {
        type: 'String',
        name: '多層膜',
        ragicId: '1000165',
      },
      ultraviolet: {
        type: 'String',
        name: 'UV',
        ragicId: '1000188',
      },
      refractiveIndex: {
        type: 'String',
        name: '折射率',
        ragicId: '1000163',
      },
      blank: {
        type: 'String',
        name: '毛料',
        ragicId: '1000164',
      },
      blankShort: {
        type: 'String',
        name: '毛料簡稱',
      },
      storageType: {
        type: 'String',
        name: '庫存/訂製',
        ragicId: '1000231',
      },
      deliveryTime: {
        type: 'String',
        name: '交期',
        ragicId: '1000233',
      },
      design: {
        type: 'String',
        name: '設計',
        ragicId: '1000166',
      },
      // C contact
      seriesRef: {
        type: 'ObjectId',
        reference: 'serieses',
        refKeys: ['key'],
        input: 'select',
        name: '商品系列名稱',
        ragicId: '1000234',
      },
      radius: {
        type: 'Number',
        name: '基弧',
        ragicId: '1000168',
      },
      replacementFrequency: {
        type: 'Number',
        name: '替換週期',
        ragicId: '1000170',
      },
      lensColor: {
        type: 'String',
        name: '隱形眼鏡顏色',
        ragicId: '1000172',
      },
      Ctype: {
        type: 'String',
        name: '類別',
        ragicId: '1000174',
      },
      waterContent: {
        type: 'Number',
        name: '含水量',
        ragicId: '1000175',
      },
      packingQuantity: {
        type: 'Number',
        name: '片數',
        ragicId: '1000194',
      },
      // D
      Dseries: {
        type: 'String',
        name: '系列(D)',
        ragicId: '1000176',
      },
      Dunit: {
        type: 'String',
        name: '單位(D)',
        ragicId: '1000178',
      },
      Dpackage: {
        type: 'String',
        name: '包裝(D)',
        ragicId: '1000179',
      },
      // E
      Etype: {
        type: 'String',
        name: '分類',
        input: 'select',
        options: [
          'B-矽膠鼻墊',
          'A-UV機',
          'A-無邊溝槽機',
          'D-眼鏡盒',
          'E-掃描槍',
          'A-詩樂工具組',
          'C-幻燈機燈管',
          'D-工具盒螺絲起子',
          'C-3M貼紙',
          'D-工具盒',
          'B-RENOMA運動鏡腳',
          'B-詩樂無邊套管',
          'B-磨片機吸盤',
          'A-烘烤機',
          'A-無邊鑽孔機',
          'A-超音波清洗機',
          'C-下巴紙',
          'C-奈米筆',
          'D-眼鏡繩',
          'D-珠鍊',
          'C-電腦驗光感熱紙',
          'D-中天紙袋',
          'D-中天塑膠袋',
          'B-T型墊片(中)',
          'B-T型墊片(小)',
          'B-氣壓式鼻墊',
          'B-全塑鼻墊',
          'B-六角無邊長螺絲',
          'B-金屬螺帽',
          'B-合口螺絲',
          'B-鼻墊螺絲',
          'B-圓腳套',
          'B-扁腳套',
          'B-矽膠鼻墊-零訂',
          'B-塑膠ㄇ型墊片(詩樂無邊)',
          'B-塑膠T型墊片',
          'B-透明塑膠墊片',
          'B-金屬無邊墊片',
          'B-螺絲帽',
          'B-螺絲母',
          'B-無邊框螺絲',
          'B-膠框螺絲',
          'B-鏡腳螺絲',
          'B-鏡片/鏡腳螺絲',
        ],
        ragicId: '1000180',
      },
      Espec: {
        type: 'String',
        name: '規格(E)',
        ragicId: '1000181',
      },
      Ecode: {
        type: 'String',
        name: 'E類商品代碼',
        ragicId: '1000439',
      },
      lockPrice: {
        type: 'String',
        input: 'select',
        name: '價格鎖定',
        options: ['非鎖定', '鎖定'],
        ragicId: '1000968',
      },
      // sync
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 130 },
        { key: 'name', width: 130 },
        { key: 'type', width: 100 },
        { key: 'salePrice', width: 100 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '商品',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name', disabled: true }],
            [{ key: 'type' }],
            [{ key: 'brandCode' }, { key: 'brandRef' }],
            [{ key: 'supplierRef' }, { key: 'orderCode' }],
            [{ key: 'unit' }],
            [{ key: 'origin' }],
            [{ key: 'note' }],
            [{ key: 'isContract' }],
            [{ key: 'orderFrom' }],
            [{ key: 'payType' }],
            [{ key: 'spec' }],
            [{ key: 'taxType' }],
            [{ key: 'basicAmount' }],
            [{ key: 'ragicStoreNodeId' }, { key: 'ragicCenterNodeId' }],
          ],
        },
        {
          name: '成本',
          rows: [
            [{ key: 'centerCost' }],
            [{ key: 'storeCost' }],
          ],
        },
        {
          name: '價格',
          rows: [
            [{ key: 'price' }],
            [{ key: 'staffPrice' }],
            [{ key: 'salePrice' }],
            [{ key: 'lockPrice' }],
          ],
        },
        {
          name: '規格 - A 類',
          rows: [
            [{ key: 'model' }],
            [{ key: 'colorRef' }],
            [{ key: 'colorCode' }],
            [{ key: 'size' }],
            [{ key: 'material' }],
            [{ key: 'contour' }],
            [{ key: 'rimType' }],
            [{ key: 'templeLength' }],
          ],
        },
        {
          name: '規格 - B 類',
          rows: [
            [{ key: 'lensTypeRef' }],
            [{ key: 'storageType' }],
            [{ key: 'sphereMax' }, { key: 'sphereMin' }],
            [{ key: 'cylinderMax' }, { key: 'cylinderMin' }],
            [{ key: 'axisMax' }, { key: 'axisMin' }],
            [{ key: 'addMax' }, { key: 'addMin' }],
            [{ key: 'SCMax' }, { key: 'SCMin' }],
            [{ key: 'progressive' }],
            [{ key: 'diameter' }],
            [{ key: 'coating' }],
            [{ key: 'ultraviolet' }],
            [{ key: 'refractiveIndex' }],
            [{ key: 'blank' }, { key: 'blankShort' }],
            [{ key: 'design' }],
          ],
        },
        {
          name: '規格 - C 類',
          rows: [
            [{ key: 'seriesRef' }],
            [{ key: 'radius' }],
            [{ key: 'replacementFrequency' }],
            [{ key: 'lensColor' }],
            [{ key: 'Ctype' }],
            [{ key: 'waterContent' }],
            [{ key: 'packingQuantity' }],
            [{ key: 'sphereMax' }, { key: 'sphereMin' }],
            [{ key: 'cylinderMax' }, { key: 'cylinderMin' }],
            [{ key: 'axisMax' }, { key: 'axisMin' }],
            [{ key: 'addMax' }, { key: 'addMin' }],
            [{ key: 'SCMax' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/products.js